















import Vue from 'vue'
export interface ITab {
  label: string,
  name: string
}
export default Vue.extend({
  name: 'UiTabs',
  props: {
    activeTab: String,
    tabs: {
      type: Array as () => ITab[],
      default () {
        return []
      }
    }
  },
  computed: {
    currentTab: {
      get (): string {
        return this.activeTab;
      },
      set () {}
    }
  }
})
